var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetamask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    className: "w-10 h-10 ",
    color: "text",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.011 3.333l-13.89 10.295L24.7 7.56l11.31-4.228z",
    fill: "#E17726"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.003 3.333l13.753 10.39-2.457-6.162L4.003 3.333zM31.015 27.202l-3.692 5.655 7.906 2.183 2.25-7.714-6.464-.124zM2.534 27.326L4.77 35.04l7.906-2.183L9 27.202l-6.465.124z",
    fill: "#E27625"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.252 17.65l-2.21 3.321 7.837.357-.274-8.441-5.353 4.763zM27.762 17.65l-5.45-4.86-.191 8.538 7.837-.357-2.196-3.322zM12.677 32.857l4.722-2.292-4.063-3.184-.659 5.476zM22.6 30.565l4.723 2.292-.66-5.476-4.062 3.184z",
    fill: "#E27625"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.323 32.858L22.6 30.565l.37 3.075-.04 1.29 4.392-2.072zM12.677 32.858l4.392 2.072-.027-1.29.357-3.075-4.722 2.293z",
    fill: "#D5BFB2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.152 25.35l-3.926-1.154L16 22.92l1.153 2.43zM22.848 25.35l1.153-2.43 2.8 1.276-3.953 1.153z",
    fill: "#233447"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.677 32.857l.687-5.655-4.365.124 3.678 5.531zM26.636 27.202l.687 5.655 3.692-5.531-4.379-.124zM29.958 20.97l-7.837.358.727 4.021 1.153-2.429 2.8 1.276 3.157-3.225zM13.226 24.197L16 22.92l1.153 2.43.727-4.022-7.837-.357 3.184 3.226z",
    fill: "#CC6228"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.042 20.97l3.294 6.41-.11-3.183-3.184-3.226zM26.801 24.197l-.137 3.184 3.294-6.41-3.157 3.226zM17.88 21.328l-.728 4.021.92 4.75.192-6.26-.385-2.511zM22.12 21.328l-.37 2.498.178 6.273.92-4.75-.727-4.021z",
    fill: "#E27525"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.848 25.35l-.92 4.749.673.466 4.063-3.184.137-3.184-3.953 1.153zM13.226 24.197l.11 3.184 4.063 3.184.672-.466-.92-4.75-3.925-1.152z",
    fill: "#F5841F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.93 34.93l.041-1.29-.343-.302h-5.257l-.329.302.027 1.29-4.392-2.073 1.537 1.263 3.116 2.155h5.34l3.115-2.155 1.538-1.263-4.393 2.073z",
    fill: "#C0AC9D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.601 30.565l-.673-.466h-3.857l-.672.466-.357 3.075.33-.302h5.256l.344.302-.371-3.075z",
    fill: "#161616"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M36.587 14.3l1.167-5.682-1.743-5.285-13.41 9.952 5.16 4.364 7.275 2.128 1.606-1.88-.7-.508 1.126-1.016-.851-.673 1.112-.837-.742-.563zM2.246 8.618l1.18 5.682-.755.563 1.112.837-.851.673 1.126 1.016-.7.507 1.605 1.88 7.289-2.127 5.147-4.364L4.003 3.333 2.246 8.618z",
    fill: "#763E1A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M35.036 19.777l-7.274-2.128 2.196 3.322-3.294 6.41 4.35-.055h6.466l-2.444-7.549zM12.252 17.65l-7.289 2.127-2.43 7.55H9l4.337.054-3.294-6.41 2.21-3.322zM22.12 21.328l.48-8.044 2.101-5.723h-9.402l2.1 5.723.48 8.044.179 2.525.013 6.245h3.857l.014-6.245.178-2.525z",
    fill: "#F5841F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamask);
export default __webpack_public_path__ + "static/media/metamask.0f1a08f5.svg";
export { ForwardRef as ReactComponent };